export function getErrorPageTextProps() {
  const isRenterHub = typeof window !== 'undefined' && location.pathname.startsWith('/renter-hub');

  return {
    homePageText: isRenterHub ? 'Return to Your Rental' : 'Return to Zillow Rental Manager',
    homePageUrl: isRenterHub ? 'https://www.zillow.com/renting/your-rental' : 'https://www.zillow.com/rental-manager/',
  };
}
